import type { CommonOptions } from "@/shared/ui";

export const TEAOR_CODES: CommonOptions = [
	{ value: "0111", label: "Gabonaféle (kivéve: rizs), hüvelyes növény, olajos mag termesztése" },
	{ value: "0112", label: "Rizstermesztés" },
	{ value: "0113", label: "Zöldségféle, dinnye, gyökér-, gumósnövény termesztése" },
	{ value: "0114", label: "Cukornádtermesztés" },
	{ value: "0115", label: "Dohánytermesztés" },
	{ value: "0116", label: "Rostnövénytermesztés" },
	{ value: "0119", label: "Egyéb, nem évelő növény termesztése" },
	{ value: "0121", label: "Szőlőtermesztés" },
	{ value: "0122", label: "Trópusi gyümölcs termesztése" },
	{ value: "0123", label: "Citrusféle termesztése" },
	{ value: "0124", label: "Almatermésű, csonthéjas termesztése" },
	{ value: "0125", label: "Egyéb gyümölcs, héjastermésű termesztése" },
	{ value: "0126", label: "Olajtartalmú gyümölcs termesztése" },
	{ value: "0127", label: "Italgyártási növény termesztése" },
	{ value: "0128", label: "Fűszer-, aroma-, narkotikus, gyógynövény termesztése" },
	{ value: "0129", label: "Egyéb évelő növény termesztése" },
	{ value: "0130", label: "Növényi szaporítóanyag termesztése" },
	{ value: "0141", label: "Tejhasznú szarvasmarha tenyésztése" },
	{ value: "0142", label: "Egyéb szarvasmarha tenyésztése" },
	{ value: "0143", label: "Ló, lóféle tenyésztése" },
	{ value: "0144", label: "Teve, teveféle tenyésztése" },
	{ value: "0145", label: "Juh, kecske tenyésztése" },
	{ value: "0146", label: "Sertéstenyésztés" },
	{ value: "0147", label: "Baromfitenyésztés" },
	{ value: "0149", label: "Egyéb állat tenyésztése" },
	{ value: "0150", label: "Vegyes gazdálkodás" },
	{ value: "0161", label: "Növénytermesztési szolgáltatás" },
	{ value: "0162", label: "Állattenyésztési szolgáltatás" },
	{ value: "0163", label: "Betakarítást követő szolgáltatás" },
	{ value: "0164", label: "Vetési célú magfeldolgozás" },
	{ value: "0170", label: "Vadgazdálkodás, vadgazdálkodási szolgáltatás" },
	{ value: "0210", label: "Erdészeti, egyéb erdőgazdálkodási tevékenység" },
	{ value: "0220", label: "Fakitermelés" },
	{ value: "0230", label: "Vadon termő egyéb erdei termék gyűjtése" },
	{ value: "0240", label: "Erdészeti szolgáltatás" },
	{ value: "0311", label: "Tengeri halászat" },
	{ value: "0312", label: "Édesvízi halászat" },
	{ value: "0321", label: "Tengerihal-gazdálkodás" },
	{ value: "0322", label: "Édesvízihal-gazdálkodás" },
	{ value: "0510", label: "Feketeszén-bányászat" },
	{ value: "0520", label: "Barnaszén-, lignitbányászat" },
	{ value: "0610", label: "Kőolaj-kitermelés" },
	{ value: "0620", label: "Földgázkitermelés" },
	{ value: "0710", label: "Vasércbányászat" },
	{ value: "0721", label: "Urán-, tóriumérc-bányászat" },
	{ value: "0729", label: "Színesfém érc bányászata" },
	{ value: "0811", label: "Kőfejtés, gipsz, kréta bányászata" },
	{ value: "0812", label: "Kavics-, homok-, agyagbányászat" },
	{ value: "0891", label: "Vegyi ásvány bányászata" },
	{ value: "0892", label: "Tőzegkitermelés" },
	{ value: "0893", label: "Sókitermelés" },
	{ value: "0899", label: "Egyéb m.n.s. bányászat" },
	{ value: "0910", label: "Kőolaj-, földgáz-kitermelési szolgáltatás" },
	{ value: "0990", label: "Egyéb bányászati szolgáltatás" },
	{ value: "1011", label: "Húsfeldolgozás, -tartósítás" },
	{ value: "1012", label: "Baromfihús feldolgozása, tartósítása" },
	{ value: "1013", label: "Hús-, baromfihús-készítmény gyártása" },
	{ value: "1020", label: "Halfeldolgozás, -tartósítás" },
	{ value: "1031", label: "Burgonyafeldolgozás, -tartósítás" },
	{ value: "1032", label: "Gyümölcs-, zöldséglé gyártása" },
	{ value: "1039", label: "Egyéb gyümölcs-, zöldségfeldolgozás, -tartósítás" },
	{ value: "1041", label: "Olaj gyártása" },
	{ value: "1042", label: "Margarin gyártása" },
	{ value: "1051", label: "Tejtermék gyártása" },
	{ value: "1052", label: "Jégkrém gyártása" },
	{ value: "1061", label: "Malomipari termék gyártása" },
	{ value: "1062", label: "Keményítő, keményítőtermék gyártása" },
	{ value: "1071", label: "Kenyér; friss pékáru gyártása" },
	{ value: "1072", label: "Tartósított lisztes áru gyártása" },
	{ value: "1073", label: "Tésztafélék gyártása" },
	{ value: "1081", label: "Cukorgyártás" },
	{ value: "1082", label: "Édesség gyártása" },
	{ value: "1083", label: "Tea, kávé feldolgozása" },
	{ value: "1084", label: "Fűszer, ételízesítő gyártása" },
	{ value: "1085", label: "Készétel gyártása" },
	{ value: "1086", label: "Homogenizált, diétás étel gyártása" },
	{ value: "1089", label: "M.n.s. egyéb élelmiszer gyártása" },
	{ value: "1091", label: "Haszonállat-eledel gyártása" },
	{ value: "1092", label: "Hobbiállat-eledel gyártása" },
	{ value: "1101", label: "Desztillált szeszes ital gyártása" },
	{ value: "1102", label: "Szőlőbor termelése" },
	{ value: "1103", label: "Gyümölcsbor termelése" },
	{ value: "1104", label: "Egyéb nem desztillált, erjesztett ital gyártása" },
	{ value: "1105", label: "Sörgyártás" },
	{ value: "1106", label: "Malátagyártás" },
	{ value: "1107", label: "Üdítőital, ásványvíz gyártása" },
	{ value: "1200", label: "Dohánytermék gyártása" },
	{ value: "1310", label: "Textilszálak fonása" },
	{ value: "1320", label: "Textilszövés" },
	{ value: "1330", label: "Textilkikészítés" },
	{ value: "1391", label: "Kötött, hurkolt kelme gyártása" },
	{ value: "1392", label: "Konfekcionált textiláru gyártása (kivéve: ruházat)" },
	{ value: "1393", label: "Szőnyeggyártás" },
	{ value: "1394", label: "Kötéláru gyártása" },
	{ value: "1395", label: "Nem szőtt textília és termék gyártása (kivéve: ruházat)" },
	{ value: "1396", label: "Műszaki textiláru gyártása" },
	{ value: "1399", label: "Egyéb textiláru gyártása m.n.s." },
	{ value: "1411", label: "Bőrruházat gyártása" },
	{ value: "1412", label: "Munkaruházat gyártása" },
	{ value: "1413", label: "Felsőruházat gyártása (kivéve: munkaruházat)" },
	{ value: "1414", label: "Alsóruházat gyártása" },
	{ value: "1419", label: "Egyéb ruházat, kiegészítők gyártása" },
	{ value: "1420", label: "Szőrmecikk gyártása" },
	{ value: "1431", label: "Kötött, hurkolt harisnyafélék gyártása" },
	{ value: "1439", label: "Egyéb kötött, hurkolt ruházati termék gyártása" },
	{ value: "1511", label: "Bőr, szőrme kikészítése" },
	{ value: "1512", label: "Táskafélék, szíjazat gyártása" },
	{ value: "1520", label: "Lábbeligyártás" },
	{ value: "1610", label: "Fűrészárugyártás" },
	{ value: "1621", label: "Falemezgyártás" },
	{ value: "1622", label: "Parkettagyártás" },
	{ value: "1623", label: "Épületasztalos-ipari termék gyártása" },
	{ value: "1624", label: "Tároló fatermék gyártása" },
	{ value: "1629", label: "Egyéb fa-, parafatermék, fonottáru gyártása" },
	{ value: "1711", label: "Papíripari rostanyag gyártása" },
	{ value: "1712", label: "Papírgyártás" },
	{ value: "1721", label: "Papír csomagolóeszköz gyártása" },
	{ value: "1722", label: "Háztartási, egészségügyi papírtermék gyártása" },
	{ value: "1723", label: "Irodai papíráru gyártása" },
	{ value: "1724", label: "Tapétagyártás" },
	{ value: "1729", label: "Egyéb papír-, kartontermék gyártása" },
	{ value: "1811", label: "Napilapnyomás" },
	{ value: "1812", label: "Nyomás (kivéve: napilap)" },
	{ value: "1813", label: "Nyomdai előkészítő tevékenység" },
	{ value: "1814", label: "Könyvkötés, kapcsolódó szolgáltatás" },
	{ value: "1820", label: "Egyéb sokszorosítás" },
	{ value: "1910", label: "Kokszgyártás" },
	{ value: "1920", label: "Kőolaj-feldolgozás" },
	{ value: "2011", label: "Ipari gáz gyártása" },
	{ value: "2012", label: "Színezék, pigment gyártása" },
	{ value: "2013", label: "Szervetlen vegyi alapanyag gyártása" },
	{ value: "2014", label: "Szerves vegyi alapanyag gyártása" },
	{ value: "2015", label: "Műtrágya, nitrogénvegyület gyártása" },
	{ value: "2016", label: "Műanyag-alapanyag gyártása" },
	{ value: "2017", label: "Szintetikus kaucsuk alapanyag gyártása" },
	{ value: "2020", label: "Mezőgazdasági vegyi termék gyártása" },
	{ value: "2030", label: "Festék, bevonóanyag gyártása" },
	{ value: "2041", label: "Tisztítószer gyártása" },
	{ value: "2042", label: "Testápolási cikk gyártása" },
	{ value: "2051", label: "Robbanóanyag gyártása" },
	{ value: "2052", label: "Ragasztószergyártás" },
	{ value: "2053", label: "Illóolajgyártás" },
	{ value: "2059", label: "M.n.s. egyéb vegyi termék gyártása" },
	{ value: "2060", label: "Vegyi szál gyártása" },
	{ value: "2110", label: "Gyógyszeralapanyag-gyártás" },
	{ value: "2120", label: "Gyógyszerkészítmény gyártása" },
	{ value: "2211", label: "Gumiabroncs, gumitömlő gyártása" },
	{ value: "2219", label: "Egyéb gumitermék gyártása" },
	{ value: "2221", label: "Műanyag lap, lemez, fólia, cső, profil gyártása" },
	{ value: "2222", label: "Műanyag csomagolóeszköz gyártása" },
	{ value: "2223", label: "Műanyag építőanyag gyártása" },
	{ value: "2229", label: "Egyéb műanyag termék gyártása" },
	{ value: "2311", label: "Síküveggyártás" },
	{ value: "2312", label: "Síküveg továbbfeldolgozása" },
	{ value: "2313", label: "Öblösüveggyártás" },
	{ value: "2314", label: "Üvegszálgyártás" },
	{ value: "2319", label: "Műszaki, egyéb üvegtermék gyártása" },
	{ value: "2320", label: "Tűzálló termék gyártása" },
	{ value: "2331", label: "Kerámiacsempe, -lap gyártása" },
	{ value: "2332", label: "Égetett agyag építőanyag gyártása" },
	{ value: "2341", label: "Háztartási kerámia gyártása" },
	{ value: "2342", label: "Egészségügyi kerámia gyártása" },
	{ value: "2343", label: "Kerámia szigetelő gyártása" },
	{ value: "2344", label: "Műszaki kerámia gyártása" },
	{ value: "2349", label: "Egyéb kerámiatermék gyártása" },
	{ value: "2351", label: "Cementgyártás" },
	{ value: "2352", label: "Mész-, gipszgyártás" },
	{ value: "2361", label: "Építési betontermék gyártása" },
	{ value: "2362", label: "Építési gipsztermék gyártása" },
	{ value: "2363", label: "Előre kevert beton gyártása" },
	{ value: "2364", label: "Habarcsgyártás" },
	{ value: "2365", label: "Szálerősítésű cement gyártása" },
	{ value: "2369", label: "Egyéb beton-, gipsz-, cementtermék gyártása" },
	{ value: "2370", label: "Kőmegmunkálás" },
	{ value: "2391", label: "Csiszolótermék gyártása" },
	{ value: "2399", label: "M.n.s. egyéb nemfém ásványi termék gyártása" },
	{ value: "2410", label: "Vas-, acél-, vasötvözet-alapanyag gyártása" },
	{ value: "2420", label: "Acélcsőgyártás" },
	{ value: "2431", label: "Hidegen húzott acélrúd gyártása" },
	{ value: "2432", label: "Hidegen hengerelt keskeny acélszalag gyártása" },
	{ value: "2433", label: "Hidegen hajlított acélidom gyártása" },
	{ value: "2434", label: "Hidegen húzott acélhuzal gyártása" },
	{ value: "2441", label: "Nemesfémgyártás" },
	{ value: "2442", label: "Alumíniumgyártás" },
	{ value: "2443", label: "Ólom, cink, ón gyártása" },
	{ value: "2444", label: "Rézgyártás" },
	{ value: "2445", label: "Egyéb nem vas fém gyártása" },
	{ value: "2446", label: "Nukleáris fűtőanyag gyártása" },
	{ value: "2451", label: "Vasöntés" },
	{ value: "2452", label: "Acélöntés" },
	{ value: "2453", label: "Könnyűfémöntés" },
	{ value: "2454", label: "Egyéb nem vas fém öntése" },
	{ value: "2511", label: "Fémszerkezet gyártása" },
	{ value: "2512", label: "Fém épületelem gyártása" },
	{ value: "2521", label: "Központi fűtési kazán, radiátor gyártása" },
	{ value: "2529", label: "Fémtartály gyártása" },
	{ value: "2530", label: "Gőzkazán gyártása" },
	{ value: "2540", label: "Fegyver-, lőszergyártás" },
	{ value: "2550", label: "Fémalakítás, porkohászat" },
	{ value: "2561", label: "Fémfelület-kezelés" },
	{ value: "2562", label: "Fémmegmunkálás" },
	{ value: "2571", label: "Evőeszköz gyártása" },
	{ value: "2572", label: "Lakat-, zárgyártás" },
	{ value: "2573", label: "Szerszámgyártás" },
	{ value: "2591", label: "Acél tárolóeszköz gyártása" },
	{ value: "2592", label: "Könnyűfém csomagolóeszköz gyártása" },
	{ value: "2593", label: "Huzaltermék gyártása" },
	{ value: "2594", label: "Kötőelem, csavar gyártása" },
	{ value: "2599", label: "M.n.s. egyéb fémfeldolgozási termék gyártása" },
	{ value: "2611", label: "Elektronikai alkatrész gyártása" },
	{ value: "2612", label: "Elektronikai áramköri kártya gyártása" },
	{ value: "2620", label: "Számítógép, perifériás egység gyártása" },
	{ value: "2630", label: "Híradás-technikai berendezés gyártása" },
	{ value: "2640", label: "Elektronikus fogyasztási cikk gyártása" },
	{ value: "2651", label: "Mérőműszergyártás" },
	{ value: "2652", label: "Óragyártás" },
	{ value: "2660", label: "Elektronikus orvosi berendezés gyártása" },
	{ value: "2670", label: "Optikai eszköz gyártása" },
	{ value: "2680", label: "Mágneses, optikai információhordozó gyártása" },
	{ value: "2711", label: "Villamos motor, áramfejlesztő gyártása" },
	{ value: "2712", label: "Áramelosztó, -szabályozó készülék gyártása" },
	{ value: "2720", label: "Akkumulátor, szárazelem gyártása" },
	{ value: "2731", label: "Száloptikai kábel gyártása" },
	{ value: "2732", label: "Egyéb elektronikus, villamos vezeték, kábel gyártása" },
	{ value: "2733", label: "Szerelvény gyártása" },
	{ value: "2740", label: "Villamos világítóeszköz gyártása" },
	{ value: "2751", label: "Háztartási villamos készülék gyártása" },
	{ value: "2752", label: "Nem villamos háztartási készülék gyártása" },
	{ value: "2790", label: "Egyéb villamos berendezés gyártása" },
	{ value: "2811", label: "Motor, turbina gyártása (kivéve: légi, közútijármű-motor)" },
	{ value: "2812", label: "Hidraulikus, pneumatikus berendezés gyártása" },
	{ value: "2813", label: "Egyéb szivattyú, kompresszor gyártása" },
	{ value: "2814", label: "Csap, szelep gyártása" },
	{ value: "2815", label: "Csapágy, erőátviteli elem gyártása" },
	{ value: "2821", label: "Fűtőberendezés, kemence gyártása" },
	{ value: "2822", label: "Emelő-, anyagmozgató gép gyártása" },
	{ value: "2823", label: "Irodagép gyártása (kivéve: számítógép és perifériái)" },
	{ value: "2824", label: "Gépi meghajtású hordozható kézi szerszámgép gyártása" },
	{ value: "2825", label: "Nem háztartási hűtő, légállapot-szabályozó gyártása" },
	{ value: "2829", label: "M.n.s. egyéb általános rendeltetésű gép gyártása" },
	{ value: "2830", label: "Mezőgazdasági, erdészeti gép gyártása" },
	{ value: "2841", label: "Fémmegmunkáló szerszámgép gyártása" },
	{ value: "2849", label: "Egyéb szerszámgép gyártása" },
	{ value: "2891", label: "Kohászati gép gyártása" },
	{ value: "2892", label: "Bányászati, építőipari gép gyártása" },
	{ value: "2893", label: "Élelmiszer-, dohányipari gép gyártása" },
	{ value: "2894", label: "Textil-, ruházati, bőripari gép gyártása" },
	{ value: "2895", label: "Papíripari gép gyártása" },
	{ value: "2896", label: "Műanyag-, gumifeldolgozó gép gyártása" },
	{ value: "2899", label: "M.n.s. egyéb speciális gép gyártása" },
	{ value: "2910", label: "Közúti gépjármű gyártása" },
	{ value: "2920", label: "Gépjármű-karosszéria, pótkocsi gyártása" },
	{ value: "2931", label: "Járművillamossági, -elektronikai készülékek gyártása" },
	{ value: "2932", label: "Közúti jármű alkatrészeinek gyártása" },
	{ value: "3011", label: "Hajógyártás" },
	{ value: "3012", label: "Szabadidő-, sporthajó gyártása" },
	{ value: "3020", label: "Vasúti, kötöttpályás jármű gyártása" },
	{ value: "3030", label: "Légi, űrjármű gyártása" },
	{ value: "3040", label: "Katonai harcjármű gyártása" },
	{ value: "3091", label: "Motorkerékpár gyártása" },
	{ value: "3092", label: "Kerékpár, mozgássérültkocsi gyártása" },
	{ value: "3099", label: "M.n.s. egyéb jármű gyártása" },
	{ value: "3101", label: "Irodabútor gyártása" },
	{ value: "3102", label: "Konyhabútorgyártás" },
	{ value: "3103", label: "Ágybetét gyártása" },
	{ value: "3109", label: "Egyéb bútor gyártása" },
	{ value: "3211", label: "Érmegyártás" },
	{ value: "3212", label: "Ékszergyártás" },
	{ value: "3213", label: "Divatékszer gyártása" },
	{ value: "3220", label: "Hangszergyártás" },
	{ value: "3230", label: "Sportszergyártás" },
	{ value: "3240", label: "Játékgyártás" },
	{ value: "3250", label: "Orvosi eszköz gyártása" },
	{ value: "3291", label: "Seprű-, kefegyártás" },
	{ value: "3299", label: "Egyéb m.n.s feldolgozóipari tevékenység" },
	{ value: "3311", label: "Fémfeldolgozási termék javítása" },
	{ value: "3312", label: "Ipari gép, berendezés javítása" },
	{ value: "3313", label: "Elektronikus, optikai eszköz javítása" },
	{ value: "3314", label: "Ipari villamos gép, berendezés javítása" },
	{ value: "3315", label: "Hajó, csónak javítása" },
	{ value: "3316", label: "Repülőgép, űrhajó javítása" },
	{ value: "3317", label: "Egyéb közlekedési eszköz javítása" },
	{ value: "3319", label: "Egyéb ipari eszköz javítása" },
	{ value: "3320", label: "Ipari gép, berendezés üzembe helyezése" },
	{ value: "3511", label: "Villamosenergia-termelés" },
	{ value: "3512", label: "Villamosenergia-szállítás" },
	{ value: "3513", label: "Villamosenergia-elosztás" },
	{ value: "3514", label: "Villamosenergia-kereskedelem" },
	{ value: "3521", label: "Gázgyártás" },
	{ value: "3522", label: "Gázelosztás" },
	{ value: "3523", label: "Gázkereskedelem" },
	{ value: "3530", label: "Gőzellátás, légkondicionálás" },
	{ value: "3600", label: "Víztermelés, -kezelés, -ellátás" },
	{ value: "3700", label: "Szennyvíz gyűjtése, kezelése" },
	{ value: "3811", label: "Nem veszélyes hulladék gyűjtése" },
	{ value: "3812", label: "Veszélyes hulladék gyűjtése" },
	{ value: "3821", label: "Nem veszélyes hulladék kezelése, ártalmatlanítása" },
	{ value: "3822", label: "Veszélyes hulladék kezelése, ártalmatlanítása" },
	{ value: "3831", label: "Használt eszköz bontása" },
	{ value: "3832", label: "Hulladék újrahasznosítása" },
	{ value: "3900", label: "Szennyeződésmentesítés, egyéb hulladékkezelés" },
	{ value: "4110", label: "Épületépítési projekt szervezése" },
	{ value: "4120", label: "Lakó- és nem lakó épület építése" },
	{ value: "4211", label: "Út, autópálya építése" },
	{ value: "4212", label: "Vasút építése" },
	{ value: "4213", label: "Híd, alagút építése" },
	{ value: "4221", label: "Folyadék szállítására szolgáló közmű építése" },
	{ value: "4222", label: "Elektromos, híradás-technikai célú közmű építése" },
	{ value: "4291", label: "Vízi létesítmény építése" },
	{ value: "4299", label: "Egyéb m.n.s. építés" },
	{ value: "4311", label: "Bontás" },
	{ value: "4312", label: "Építési terület előkészítése" },
	{ value: "4313", label: "Talajmintavétel, próbafúrás" },
	{ value: "4321", label: "Villanyszerelés" },
	{ value: "4322", label: "Víz-, gáz-, fűtés-, légkondicionáló-szerelés" },
	{ value: "4329", label: "Egyéb épületgépészeti szerelés" },
	{ value: "4331", label: "Vakolás" },
	{ value: "4332", label: "Épületasztalos-szerkezet szerelése" },
	{ value: "4333", label: "Padló-, falburkolás" },
	{ value: "4334", label: "Festés, üvegezés" },
	{ value: "4339", label: "Egyéb befejező építés m.n.s." },
	{ value: "4391", label: "Tetőfedés, tetőszerkezet-építés" },
	{ value: "4399", label: "Egyéb speciális szaképítés m.n.s." },
	{ value: "4511", label: "Személygépjármű-, könnyűgépjármű-kereskedelem" },
	{ value: "4519", label: "Egyéb gépjármű-kereskedelem" },
	{ value: "4520", label: "Gépjárműjavítás, -karbantartás" },
	{ value: "4531", label: "Gépjárműalkatrész-nagykereskedelem" },
	{ value: "4532", label: "Gépjárműalkatrész-kiskereskedelem" },
	{ value: "4540", label: "Motorkerékpár, -alkatrész kereskedelme, javítása" },
	{ value: "4611", label: "Mezőgazdasági termék ügynöki nagykereskedelme" },
	{
		value: "4612",
		label: "Tüzelő- és üzemanyag, érc, fém és vegyipari alapanyag ügynöki nagykereskedelme",
	},
	{ value: "4613", label: "Fa-, építési anyag ügynöki nagykereskedelme" },
	{ value: "4614", label: "Gép, hajó, repülőgép ügynöki nagykereskedelme" },
	{ value: "4615", label: "Bútor, háztartási áru, fémáru ügynöki nagykereskedelme" },
	{ value: "4616", label: "Textil, ruházat, lábbeli, bőráru ügynöki nagykereskedelme" },
	{ value: "4617", label: "Élelmiszer, ital, dohányáru ügynöki nagykereskedelme" },
	{ value: "4618", label: "Egyéb termék ügynöki nagykereskedelme" },
	{ value: "4619", label: "Vegyes termékkörű ügynöki nagykereskedelem" },
	{ value: "4621", label: "Gabona, dohány, vetőmag, takarmány nagykereskedelme" },
	{ value: "4622", label: "Dísznövény nagykereskedelme" },
	{ value: "4623", label: "Élőállat nagykereskedelme" },
	{ value: "4624", label: "Bőr nagykereskedelme" },
	{ value: "4631", label: "Zöldség-, gyümölcs-nagykereskedelem" },
	{ value: "4632", label: "Hús-, húskészítmény nagykereskedelme" },
	{ value: "4633", label: "Tejtermék, tojás, zsiradék nagykereskedelme" },
	{ value: "4634", label: "Ital nagykereskedelme" },
	{ value: "4635", label: "Dohányáru nagykereskedelme" },
	{ value: "4636", label: "Cukor, édesség nagykereskedelme" },
	{ value: "4637", label: "Kávé-, tea-, kakaó-, fűszer-nagykereskedelem" },
	{ value: "4638", label: "Egyéb élelmiszer nagykereskedelme" },
	{ value: "4639", label: "Élelmiszer, ital, dohányáru vegyes nagykereskedelme" },
	{ value: "4641", label: "Textil-nagykereskedelem" },
	{ value: "4642", label: "Ruházat, lábbeli nagykereskedelme" },
	{ value: "4643", label: "Elektromos háztartási cikk nagykereskedelme" },
	{ value: "4644", label: "Porcelán-, üvegáru-, tisztítószer-nagykereskedelem" },
	{ value: "4645", label: "Illatszer nagykereskedelme" },
	{ value: "4646", label: "Gyógyszer, gyógyászati termék nagykereskedelme" },
	{ value: "4647", label: "Bútor, szőnyeg, világítóberendezés nagykereskedelme" },
	{ value: "4648", label: "Óra-, ékszer-nagykereskedelem" },
	{ value: "4649", label: "Egyéb háztartási cikk nagykereskedelme m.n.s." },
	{ value: "4651", label: "Számítógép, periféria, szoftver nagykereskedelme" },
	{
		value: "4652",
		label: "Elektronikus, híradás-technikai berendezés, és alkatrészei nagykereskedelme",
	},
	{ value: "4661", label: "Mezőgazdasági gép, berendezés nagykereskedelme" },
	{ value: "4662", label: "Szerszámgép-nagykereskedelem" },
	{ value: "4663", label: "Bányászati-, építőipari gép nagykereskedelme" },
	{ value: "4664", label: "Textilipari gép, varró-, kötőgép nagykereskedelme" },
	{ value: "4665", label: "Irodabútor-nagykereskedelem" },
	{ value: "4666", label: "Egyéb irodagép, -berendezés nagykereskedelme" },
	{ value: "4669", label: "Egyéb m.n.s. gép, berendezés nagykereskedelme" },
	{ value: "4671", label: "Üzem-, tüzelőanyag nagykereskedelme" },
	{ value: "4672", label: "Fém-, érc-nagykereskedelem" },
	{ value: "4673", label: "Fa-, építőanyag-, szaniteráru-nagykereskedelem" },
	{ value: "4674", label: "Fémáru, szerelvény, fűtési berendezés nagykereskedelme" },
	{ value: "4675", label: "Vegyi áru nagykereskedelme" },
	{ value: "4676", label: "Egyéb termelési célú termék nagykereskedelme" },
	{ value: "4677", label: "Hulladék-nagykereskedelem" },
	{ value: "4690", label: "Vegyestermékkörű nagykereskedelem" },
	{ value: "4711", label: "Élelmiszer jellegű bolti vegyes kiskereskedelem" },
	{ value: "4719", label: "Iparcikk jellegű bolti vegyes kiskereskedelem" },
	{ value: "4721", label: "Zöldség, gyümölcs kiskereskedelme" },
	{ value: "4722", label: "Hús-, húskészítmény kiskereskedelme" },
	{ value: "4723", label: "Hal kiskereskedelme" },
	{ value: "4724", label: "Kenyér-, pékáru-, édesség-kiskereskedelem" },
	{ value: "4725", label: "Ital-kiskereskedelem" },
	{ value: "4726", label: "Dohányáru-kiskereskedelem" },
	{ value: "4729", label: "Egyéb élelmiszer-kiskereskedelem" },
	{ value: "4730", label: "Gépjárműüzemanyag-kiskereskedelem" },
	{ value: "4741", label: "Számítógép, periféria, szoftver kiskereskedelme" },
	{ value: "4742", label: "Telekommunikációs termék kiskereskedelme" },
	{ value: "4743", label: "Audio-, videoberendezés kiskereskedelme" },
	{ value: "4751", label: "Textil-kiskereskedelem" },
	{ value: "4752", label: "Vasáru-, festék-, üveg-kiskereskedelem" },
	{ value: "4753", label: "Szőnyeg, fal-, padlóburkoló kiskereskedelme" },
	{ value: "4754", label: "Villamos háztartási készülék kiskereskedelme" },
	{ value: "4759", label: "Bútor, világítási eszköz, egyéb háztartási cikk kiskereskedelme" },
	{ value: "4761", label: "Könyv-kiskereskedelem" },
	{ value: "4762", label: "Újság-, papíráru-kiskereskedelem" },
	{ value: "4763", label: "Zene-, videofelvétel kiskereskedelme" },
	{ value: "4764", label: "Sportszer-kiskereskedelem" },
	{ value: "4765", label: "Játék-kiskereskedelem" },
	{ value: "4771", label: "Ruházat kiskereskedelem" },
	{ value: "4772", label: "Lábbeli-, bőráru-kiskereskedelem" },
	{ value: "4773", label: "Gyógyszer-kiskereskedelem" },
	{ value: "4774", label: "Gyógyászati termék kiskereskedelme" },
	{ value: "4775", label: "Illatszer-kiskereskedelem" },
	{ value: "4776", label: "Dísznövény, vetőmag, műtrágya, hobbiállat-eledel kiskereskedelme" },
	{ value: "4777", label: "Óra-, ékszer-kiskereskedelem" },
	{ value: "4778", label: "Egyéb m.n.s. új áru kiskereskedelme" },
	{ value: "4779", label: "Használtcikk bolti kiskereskedelme" },
	{ value: "4781", label: "Élelmiszer, ital, dohányáru piaci kiskereskedelme" },
	{ value: "4782", label: "Textil, ruházat, lábbeli piaci kiskereskedelme" },
	{ value: "4789", label: "Egyéb áruk piaci kiskereskedelme" },
	{ value: "4791", label: "Csomagküldő, internetes kiskereskedelem" },
	{ value: "4799", label: "Egyéb nem bolti, piaci kiskereskedelem" },
	{ value: "4910", label: "Helyközi vasúti személyszállítás" },
	{ value: "4920", label: "Vasúti áruszállítás" },
	{ value: "4931", label: "Városi, elővárosi szárazföldi személyszállítás" },
	{ value: "4932", label: "Taxis személyszállítás" },
	{ value: "4939", label: "M.n.s. egyéb szárazföldi személyszállítás" },
	{ value: "4941", label: "Közúti áruszállítás" },
	{ value: "4942", label: "Költöztetés" },
	{ value: "4950", label: "Csővezetékes szállítás" },
	{ value: "5010", label: "Tengeri személyszállítás" },
	{ value: "5020", label: "Tengeri áruszállítás" },
	{ value: "5030", label: "Belvízi személyszállítás" },
	{ value: "5040", label: "Belvízi áruszállítás" },
	{ value: "5110", label: "Légi személyszállítás" },
	{ value: "5121", label: "Légi áruszállítás" },
	{ value: "5122", label: "Űrszállítás" },
	{ value: "5210", label: "Raktározás, tárolás" },
	{ value: "5221", label: "Szárazföldi szállítást kiegészítő szolgáltatás" },
	{ value: "5222", label: "Vízi szállítást kiegészítő szolgáltatás" },
	{ value: "5223", label: "Légi szállítást kiegészítő szolgáltatás" },
	{ value: "5224", label: "Rakománykezelés" },
	{ value: "5229", label: "Egyéb szállítást kiegészítő szolgáltatás" },
	{ value: "5310", label: "Postai tevékenység (egyetemes kötelezettséggel)" },
	{ value: "5320", label: "Egyéb postai, futárpostai tevékenység" },
	{ value: "5510", label: "Szállodai szolgáltatás" },
	{ value: "5520", label: "Üdülési, egyéb átmeneti szálláshely-szolgáltatás" },
	{ value: "5530", label: "Kempingszolgáltatás" },
	{ value: "5590", label: "Egyéb szálláshely-szolgáltatás" },
	{ value: "5610", label: "Éttermi, mozgó vendéglátás" },
	{ value: "5621", label: "Rendezvényi étkeztetés" },
	{ value: "5629", label: "Egyéb vendéglátás" },
	{ value: "5630", label: "Italszolgáltatás" },
	{ value: "5811", label: "Könyvkiadás" },
	{ value: "5812", label: "Címtárak, levelezőjegyzékek kiadása" },
	{ value: "5813", label: "Napilapkiadás" },
	{ value: "5814", label: "Folyóirat, időszaki kiadvány kiadása" },
	{ value: "5819", label: "Egyéb kiadói tevékenység" },
	{ value: "5821", label: "Számítógépes játék kiadása" },
	{ value: "5829", label: "Egyéb szoftverkiadás" },
	{ value: "5911", label: "Film-, video-, televízióműsor-gyártás" },
	{ value: "5912", label: "Film-, videogyártás, televíziós műsorfelvétel utómunkálatai" },
	{ value: "5913", label: "Film-, video- és televízióprogram terjesztése" },
	{ value: "5914", label: "Filmvetítés" },
	{ value: "5920", label: "Hangfelvétel készítése, kiadása" },
	{ value: "6010", label: "Rádióműsor-szolgáltatás" },
	{ value: "6020", label: "Televízióműsor összeállítása, szolgáltatása" },
	{ value: "6110", label: "Vezetékes távközlés" },
	{ value: "6120", label: "Vezeték nélküli távközlés" },
	{ value: "6130", label: "Műholdas távközlés" },
	{ value: "6190", label: "Egyéb távközlés" },
	{ value: "6201", label: "Számítógépes programozás" },
	{ value: "6202", label: "Információ-technológiai szaktanácsadás" },
	{ value: "6203", label: "Számítógép-üzemeltetés" },
	{ value: "6209", label: "Egyéb információ-technológiai szolgáltatás" },
	{ value: "6311", label: "Adatfeldolgozás, web-hoszting szolgáltatás" },
	{ value: "6312", label: "Világháló-portál szolgáltatás" },
	{ value: "6391", label: "Hírügynökségi tevékenység" },
	{ value: "6399", label: "M.n.s. egyéb információs szolgáltatás" },
	{ value: "6411", label: "Jegybanki tevékenység" },
	{ value: "6419", label: "Egyéb monetáris közvetítés" },
	{ value: "6420", label: "Vagyonkezelés (holding)" },
	{ value: "6430", label: "Befektetési alapok és hasonlók" },
	{ value: "6491", label: "Pénzügyi lízing" },
	{ value: "6492", label: "Egyéb hitelnyújtás" },
	{ value: "6499", label: "M.n.s. egyéb pénzügyi közvetítés" },
	{ value: "6511", label: "Életbiztosítás" },
	{ value: "6512", label: "Nem életbiztosítás" },
	{ value: "6520", label: "Viszontbiztosítás" },
	{ value: "6530", label: "Nyugdíjalapok" },
	{ value: "6611", label: "Pénz-, tőkepiac igazgatása" },
	{ value: "6612", label: "Értékpapír-, árutőzsdei ügynöki tevékenység" },
	{ value: "6619", label: "Egyéb pénzügyi kiegészítő tevékenység" },
	{ value: "6621", label: "Kockázatértékelés, kárszakértés" },
	{ value: "6622", label: "Biztosítási ügynöki, brókeri tevékenység" },
	{ value: "6629", label: "Biztosítás, nyugdíjalap egyéb kiegészítő tevékenysége" },
	{ value: "6630", label: "Alapkezelés" },
	{ value: "6810", label: "Saját tulajdonú ingatlan adásvétele" },
	{ value: "6820", label: "Saját tulajdonú, bérelt ingatlan bérbeadása, üzemeltetése" },
	{ value: "6831", label: "Ingatlanügynöki tevékenység" },
	{ value: "6832", label: "Ingatlankezelés" },
	{ value: "6910", label: "Jogi tevékenység" },
	{ value: "6920", label: "Számviteli, könyvvizsgálói, adószakértői tevékenység" },
	{ value: "7010", label: "Üzletvezetés" },
	{ value: "7021", label: "PR, kommunikáció" },
	{ value: "7022", label: "Üzletviteli, egyéb vezetési tanácsadás" },
	{ value: "7111", label: "Építészmérnöki tevékenység" },
	{ value: "7112", label: "Mérnöki tevékenység, műszaki tanácsadás" },
	{ value: "7120", label: "Műszaki vizsgálat, elemzés" },
	{ value: "7211", label: "Biotechnológiai kutatás, fejlesztés" },
	{ value: "7219", label: "Egyéb természettudományi, műszaki kutatás, fejlesztés" },
	{ value: "7220", label: "Társadalomtudományi, humán kutatás, fejlesztés" },
	{ value: "7311", label: "Reklámügynöki tevékenység" },
	{ value: "7312", label: "Médiareklám" },
	{ value: "7320", label: "Piac-, közvélemény-kutatás" },
	{ value: "7410", label: "Divat-, formatervezés" },
	{ value: "7420", label: "Fényképészet" },
	{ value: "7430", label: "Fordítás, tolmácsolás" },
	{ value: "7490", label: "M.n.s. egyéb szakmai, tudományos, műszaki tevékenység" },
	{ value: "7500", label: "Állat-egészségügyi ellátás" },
	{ value: "7711", label: "Személygépjármű kölcsönzése" },
	{ value: "7712", label: "Gépjárműkölcsönzés (3,5 tonna fölött)" },
	{ value: "7721", label: "Szabadidős, sporteszköz kölcsönzése" },
	{ value: "7722", label: "Videokazetta, lemez kölcsönzése" },
	{ value: "7729", label: "Egyéb személyi használatú, háztartási cikk kölcsönzése" },
	{ value: "7731", label: "Mezőgazdasági gép kölcsönzése" },
	{ value: "7732", label: "Építőipari gép kölcsönzése" },
	{ value: "7733", label: "Irodagép kölcsönzése (beleértve: számítógép)" },
	{ value: "7734", label: "Vízi szállítóeszköz kölcsönzése" },
	{ value: "7735", label: "Légi szállítóeszköz kölcsönzése" },
	{ value: "7739", label: "Egyéb gép, tárgyi eszköz kölcsönzése" },
	{ value: "7740", label: "Immateriális javak kölcsönzése" },
	{ value: "7810", label: "Munkaközvetítés" },
	{ value: "7820", label: "Munkaerőkölcsönzés" },
	{ value: "7830", label: "Egyéb emberierőforrás-ellátás, -gazdálkodás" },
	{ value: "7911", label: "Utazásközvetítés" },
	{ value: "7912", label: "Utazásszervezés" },
	{ value: "7990", label: "Egyéb foglalás" },
	{ value: "8010", label: "Személybiztonsági tevékenység" },
	{ value: "8020", label: "Biztonsági rendszer szolgáltatás" },
	{ value: "8030", label: "Nyomozás" },
	{ value: "8110", label: "Építményüzemeltetés" },
	{ value: "8121", label: "Általános épülettakarítás" },
	{ value: "8122", label: "Egyéb épület-, ipari takarítás" },
	{ value: "8129", label: "Egyéb takarítás" },
	{ value: "8130", label: "Zöldterület-kezelés" },
	{ value: "8211", label: "Összetett adminisztratív szolgáltatás" },
	{ value: "8219", label: "Fénymásolás, egyéb irodai szolgáltatás" },
	{ value: "8220", label: "Telefoninformáció" },
	{ value: "8230", label: "Konferencia, kereskedelmi bemutató szervezése" },
	{ value: "8291", label: "Követelésbehajtás" },
	{ value: "8292", label: "Csomagolás" },
	{ value: "8299", label: "M.n.s. egyéb kiegészítő üzleti szolgáltatás" },
	{ value: "8411", label: "Általános közigazgatás" },
	{
		value: "8412",
		label: "Egészségügy, oktatás, kultúra, egyéb szociális szolgáltatás (kivéve: társadalombiztosítás) igazgatása",
	},
	{ value: "8413", label: "Üzleti élet szabályozása, hatékonyságának ösztönzése" },
	{ value: "8421", label: "Külügyek" },
	{ value: "8422", label: "Honvédelem" },
	{ value: "8423", label: "Igazságügy, bíróság" },
	{ value: "8424", label: "Közbiztonság, közrend" },
	{ value: "8425", label: "Tűzvédelem" },
	{ value: "8430", label: "Kötelező társadalombiztosítás" },
	{ value: "8510", label: "Iskolai előkészítő oktatás" },
	{ value: "8520", label: "Alapfokú oktatás" },
	{ value: "8531", label: "Általános középfokú oktatás" },
	{ value: "8532", label: "Szakmai középfokú oktatás" },
	{ value: "8541", label: "Felső szintű, nem felsőfokú oktatás" },
	{ value: "8542", label: "Felsőfokú oktatás" },
	{ value: "8551", label: "Sport, szabadidős képzés" },
	{ value: "8552", label: "Kulturális képzés" },
	{ value: "8553", label: "Járművezető-oktatás" },
	{ value: "8559", label: "M.n.s. egyéb oktatás" },
	{ value: "8560", label: "Oktatást kiegészítő tevékenység" },
	{ value: "8610", label: "Fekvőbeteg-ellátás" },
	{ value: "8621", label: "Általános járóbeteg-ellátás" },
	{ value: "8622", label: "Szakorvosi járóbeteg-ellátás" },
	{ value: "8623", label: "Fogorvosi járóbeteg-ellátás" },
	{ value: "8690", label: "Egyéb humán-egészségügyi ellátás" },
	{ value: "8710", label: "Bentlakásos, nem kórházi ápolás" },
	{ value: "8720", label: "Mentális, szenvedélybeteg bentlakásos ellátása" },
	{ value: "8730", label: "Idősek, fogyatékosok bentlakásos ellátása" },
	{ value: "8790", label: "Egyéb bentlakásos ellátás" },
	{ value: "8810", label: "Idősek, fogyatékosok szociális ellátása bentlakás nélkül" },
	{ value: "8891", label: "Gyermekek napközbeni ellátása" },
	{ value: "8899", label: "M.n.s. egyéb szociális ellátás bentlakás nélkül" },
	{ value: "9001", label: "Előadó-művészet" },
	{ value: "9002", label: "Előadó-művészetet kiegészítő tevékenység" },
	{ value: "9003", label: "Alkotóművészet" },
	{ value: "9004", label: "Művészeti létesítmények működtetése" },
	{ value: "9101", label: "Könyvtári, levéltári tevékenység" },
	{ value: "9102", label: "Múzeumi tevékenység" },
	{ value: "9103", label: "Történelmi hely, építmény, egyéb látványosság működtetése" },
	{ value: "9104", label: "Növény-, állatkert, természetvédelmi terület működtetése" },
	{ value: "9200", label: "Szerencsejáték, fogadás" },
	{ value: "9311", label: "Sportlétesítmény működtetése" },
	{ value: "9312", label: "Sportegyesületi tevékenység" },
	{ value: "9313", label: "Testedzési szolgáltatás" },
	{ value: "9319", label: "Egyéb sporttevékenység" },
	{ value: "9321", label: "Vidámparki, szórakoztatóparki tevékenység" },
	{ value: "9329", label: "M.n.s. egyéb szórakoztatás, szabadidős tevékenység" },
	{ value: "9411", label: "Vállalkozói, munkaadói érdekképviselet" },
	{ value: "9412", label: "Szakmai érdekképviselet" },
	{ value: "9420", label: "Szakszervezeti tevékenység" },
	{ value: "9491", label: "Egyházi tevékenység" },
	{ value: "9492", label: "Politikai tevékenység" },
	{ value: "9499", label: "M.n.s. egyéb közösségi, társadalmi tevékenység" },
	{ value: "9511", label: "Számítógép, -periféria javítása" },
	{ value: "9512", label: "Kommunikációs eszköz javítása" },
	{ value: "9521", label: "Szórakoztatóelektronikai cikk javítása" },
	{ value: "9522", label: "Háztartási gép, háztartási, kerti eszköz javítása" },
	{ value: "9523", label: "Lábbeli, egyéb bőráru javítása" },
	{ value: "9524", label: "Bútor, lakberendezési tárgy javítása" },
	{ value: "9525", label: "Óra-, ékszerjavítás" },
	{ value: "9529", label: "Egyéb személyi-, háztartási cikk javítása" },
	{ value: "9601", label: "Textil, szőrme mosása, tisztítása" },
	{ value: "9602", label: "Fodrászat, szépségápolás" },
	{ value: "9603", label: "Temetkezés, temetkezést kiegészítő szolgáltatás" },
	{ value: "9604", label: "Fizikai közérzetet javító szolgáltatás" },
	{ value: "9609", label: "M.n.s. egyéb személyi szolgáltatás" },
	{ value: "9700", label: "Háztartási alkalmazottat foglalkoztató magánháztartás" },
	{ value: "9810", label: "Háztartás termék-előállítása saját fogyasztásra" },
	{ value: "9820", label: "Háztartás szolgáltatása saját fogyasztásra" },
	{ value: "9900", label: "Területen kívüli szervezet" },
];
